import { useEffect } from 'react';

declare global {
  interface Window {
    clarity: (...args: unknown[]) => void;
  }
}

export const Clarity = () => {
  useEffect(() => {
    const projectId = import.meta.env.VITE_CLARITY_ID;
    
    if (!projectId) return;

    const script = document.createElement('script');
    script.async = true;
    script.innerHTML = `
      (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", "${projectId}");
    `;
    document.head.appendChild(script);

    return () => {
      const clarityScript = document.querySelector('script[src*="clarity.ms"]');
      if (clarityScript) {
        clarityScript.remove();
      }
    };
  }, []);

  return null;
}; 